import React from 'react'

const SidebarHeader = ({onClick , title}) => {
  return (
    <div className=" flex justify-start gap-5 items-center ">
           
    <svg
      onClick={onClick}
      className="cursor-pointer"
      width="15"
      height="34"
      viewBox="0 0 22 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.23223 17.2322C0.255922 18.2085 0.255922 19.7915 1.23223 20.7678L17.1421 36.6777C18.1184 37.654 19.7014 37.654 20.6777 36.6777C21.654 35.7014 21.654 34.1184 20.6777 33.1421L6.53553 19L20.6777 4.85786C21.654 3.88155 21.654 2.29864 20.6777 1.32233C19.7014 0.34602 18.1184 0.34602 17.1421 1.32233L1.23223 17.2322ZM5 16.5L3 16.5L3 21.5L5 21.5L5 16.5Z"
        fill="#399E79"
      />
    </svg>
    <h2 className=" font-semibold text-xl md:text-3xl lg:text-3xl 4xl:text-4xl ">
      {/* md:text-3xl lg:text-3xl l px-5 xl:mx-20  ml-16 lg:ml-0 font-semibold 4xl:text-4xl   */}
      {title}
    </h2>
  </div>
  )
}

export default SidebarHeader
